var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12 0 C 8.9426113 0 6.309955 0.29967448 4.7363281 0.73242188 L 5.2675781 2.6601562 C 6.4939513 2.3229037 9.0813887 2 12 2 C 14.920658 2 17.508002 2.3229037 18.734375 2.6601562 L 19.265625 0.73242188 C 17.691998 0.29967448 15.059342 0 12 0 z M 8 4 C 5.79 4 4 5.79 4 8 L 4 19 L 4 22.263672 C 4 22.670672 4.336 23 4.75 23 L 7 23 L 7 22 L 17 22 L 17 23 L 19.25 23 C 19.664 23 20 22.670672 20 22.263672 L 20 19 L 20 8 C 20 5.79 18.21 4 16 4 L 8 4 z M 8 6 L 16 6 C 17.1 6 18 6.9 18 8 L 18 13 L 6 13 L 6 8 C 6 6.9 6.9 6 8 6 z M 12 16 C 12.55 16 13 16.45 13 17 C 13 17.55 12.55 18 12 18 C 11.45 18 11 17.55 11 17 C 11 16.45 11.45 16 12 16 z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.032dedd3153f3c525b3df83717d5606c.svg";
export { ForwardRef as ReactComponent };